import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { getText, trackGA } from 'misc/helpers';

class Welcome extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="complement-content register-info">
                    <img className="complement-logo" src="assets/images/verify/ico_dm_v.svg" alt="" />
                    <h1>{getText('_2_4_titel_welcome', 'Väkommen')}</h1>
                    <p>
                        {getText(
                            '_2_4_Text_welcome',
                            'Du som har valt Digimail kommer snart börja få post från myndigheter och kommuner till din digitala brevlåda. Det gäller även brev från företag och organisationer. De brev du får till din Digimail kommer successivt att bli allt fler, medan pappershögen i din fysiska brevlåda sjunker i samma takt. Har du frågor är du alltid välkommen att kontakta oss. Du når oss snabbt och enkelt via digimail.se/kontakta oss'
                        )}
                    </p>
                    <Link to="/inbox">
                        <button className="button-yellow button-big button-agreement">{getText('Missing', 'Till brevlådan')}</button>
                    </Link>
                </div>

                <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
            </div>
        );
    }

    componentDidMount() {
        trackGA('2.4 Välkommen');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/components/views/Welcome.js